// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7165d608","67":"1b6d861e","122":"a67e399d","145":"cc27023b","178":"5697a1be","318":"31c589d9","375":"bd9ff7bd","444":"2a1594db","453":"7712f9a6","533":"43d1d29d","591":"b44d9811","845":"4149f839"}[chunkId] + ".chunk.js";
};